var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"UserRoleMap"},[_c('ShCustomValueMapper',{attrs:{"prop":_vm.role,"cursor":"pointer","map":{
                         owner: { label: 'Administrator', icon: 'fa-user-secret' },
                         manager: { label: 'Manager', icon: 'fa-user-tie' },
                         user: { label: 'Użytkownik', icon: 'fa-user' },
                         default: { label: 'Unknown', icon: 'fa-question-circle' },
                       }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }